/* SAEGE product page - test build.
 *
 *  Rating, label format "4.9 * (1,007)". ALWAYS this product's own score,
 *  always to the RIGHT of the product name:
 *    - product has FLOOR+ reviews -> its own score, right of the name.
 *    - no reviews at all          -> nothing is shown.
 *
 *    Until 11/09/26 products under a 25-review floor showed the STORE
 *    score above the title instead. That was dropped on Tom's call: with
 *    Okendo live, every product carries its own figure and the store-wide
 *    one could be read as the product's. The cost is that the 107 products
 *    with no reviews yet show no rating at all - which is the honest state,
 *    but it does mean no social proof in the buy box for them.
 *
 *    The score is read from the Okendo widget's own server-rendered JSON
 *    ([data-oke-metafield-data], further down the page), NOT from Liquid.
 *    product.metafields.okendo.summaryData is app-owned and comes back nil in
 *    a theme-authored snippet - it renders fine inside Okendo's own app block
 *    but not from ours, which is why every product silently fell to the store
 *    score on the first attempt. The widget markup is printed server-side from
 *    that same metafield, so the figure is in the HTML at parse time and
 *    nothing waits on a network call. The loader still emits the Liquid value
 *    and it wins when non-zero, in case that access is ever granted. It
 *    also still emits the store-wide figure, now unused here, so the old
 *    behaviour can be restored without touching the loader.
 *
 *    REVIEWS SOURCE CHANGED TO OKENDO (Sept 2026). This used to hang off the
 *    Loox rating app block (.loox-rating) as its anchor, with Loox's stars
 *    hidden and its own text set to font-size:0 - nothing Loox rendered was
 *    ever visible, only its numbers were used. So the swap is invisible: the
 *    element is now built here instead of borrowed, and the label, the two
 *    modes and the CSS are unchanged.
 *
 *    Because the anchor is ours there is no third-party re-render to fight
 *    and no MutationObserver: Loox used to wipe its own child nodes after
 *    first paint, which is the only thing that observer existed for.
 *
 *    The store figure has no Okendo equivalent - Okendo writes per-product
 *    summaryData but no shop-level aggregate - so custom.okendo_global_stats
 *    is a metafield we set ourselves by summing every product's summaryData.
 *    IT DOES NOT UPDATE ITSELF. Re-sum it when the store-wide figure has
 *    drifted enough to matter.
 *
 *  Klarna: placed directly under the price using flex ORDER on the buy column,
 *  NOT by moving the node. That block is server-rendered Liquid and does not
 *  survive relocation - moving it leaves it empty or removes it. Only classes
 *  are added here; nothing is reparented.
 *
 *  Trust lines: under Add to Bag. Also hides the theme's own US-only trust row.
 *
 * Loaded from snippets/saege-pdp-loader.liquid, product templates only.
 * Styles: assets/saege-pdp.css
 */
(function () {
  'use strict';

  /* Minimum reviews before this product's score is shown at all.
     Counted 11/09/26 across 270 active products: 36 have 25+ reviews,
     13 have 10-24, 19 have 5-9, 114 have 1-4 and 88 have none.

     Set back to 1 on Tom's call 14/09/26. At 5 the rating vanished from
     every product with 1-4 reviews - Ocean Birthstone Necklace showing
     2 reviews at the bottom of the page but no rating by the title read
     as a bug rather than a threshold. Tom's call is that any product with
     reviews shows its score. The cost is the 14 products whose score is
     under 4.0 on one to four reviews, worst being Pearl Drop Earring Gold
     at 1.8 from 4.

     Raising or lowering this is a one-number change - nothing else in
     this file depends on it. */
  var FLOOR = 1;
  var ICONS = true;
  var STAR = '★';
  var DATA = window.SAEGE_PDP || { rating: 0, count: 0, storeRating: 0, storeCount: 0 };

  var ICON = {
    shield: '<path d="M12 3l7 3v6c0 4.5-3 7.8-7 9-4-1.2-7-4.5-7-9V6l7-3z"/>',
    leaf: '<path d="M20 4c0 8-5 13-13 13H4.5C4.5 9 9.5 4 17 4h3z"/><path d="M4 20c2.5-3.5 6-6.5 10.5-8.5"/>',
    truck: '<path d="M2 7h11v9H2z"/><path d="M13 10.5h4l3 3V16h-7z"/><circle cx="6" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>',
    ret: '<path d="M4.5 9.5h10a4 4 0 0 1 0 8H9"/><path d="M8 5.5l-3.5 4 3.5 4"/>'
  };

  var ITEMS = [
    { icon: 'shield', text: 'Lifetime colour guarantee' },
    { icon: 'leaf', text: 'Hypoallergenic, nickel-free' },
    { icon: 'truck', text: 'All duties &amp; taxes covered' },
    { icon: 'ret', text: 'Hassle-free returns' }
  ];

  function svg(name) {
    return '<svg class="saege-trust__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICON[name] + '</svg>';
  }

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function firstVisible(sel) {
    var list = document.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) if (isVisible(list[i])) return list[i];
    return null;
  }

  function fmt(rating, count) {
    return Number(rating).toFixed(1) + ' ' + STAR + ' (' + Number(count).toLocaleString() + ')';
  }

  /* Klarna under the price, by flex order only. */
  function tagOrder() {
    var titleRow = firstVisible('.detail .title-row, .product-detail .title-row');
    if (!titleRow) return false;
    var col = titleRow.parentElement;
    if (!col) return false;

    var klarna = document.querySelector('.saege-klarna');
    var rating = document.querySelector('.saege-rating');
    var price = firstVisible('.detail .price-container, .product-detail .price-container');

    col.classList.add('saege-ordered');
    titleRow.classList.add('saege-o-title');
    if (price) price.classList.add('saege-o-price');

    /* product-level pages move the rating INTO the title row, and walking up
       from it would then tag the title row itself as the rating slot */
    if (rating && !titleRow.contains(rating)) {
      var rw = rating.closest('.shopify-block') || rating;
      while (rw && rw.parentElement !== col) rw = rw.parentElement;
      if (rw && rw !== titleRow) rw.classList.add('saege-o-rating');
    }

    if (klarna) {
      var kw = klarna;
      while (kw && kw.parentElement !== col) kw = kw.parentElement;
      if (kw) kw.classList.add('saege-o-klarna');
    }
    return !!klarna;
  }

  /* Trust lines */
  function insertTrust() {
    if (document.querySelector('.saege-trust')) return true;
    var buy = firstVisible('.buy-buttons-row');
    if (!buy || !buy.parentNode) return false;
    var wrap = document.createElement('div');
    wrap.className = 'saege-trust' + (ICONS ? ' saege-trust--icons' : '');
    wrap.innerHTML = '<div class="saege-trust__grid">' + ITEMS.map(function (it) {
      return '<div class="saege-trust__item">' + (ICONS ? svg(it.icon) : '') + '<span>' + it.text + '</span></div>';
    }).join('') + '</div>';
    buy.parentNode.insertBefore(wrap, buy.nextSibling);
    return true;
  }

  function hideLegacyTrust() {
    var items = document.querySelectorAll('.trust-item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].parentElement) items[i].parentElement.classList.add('saege-legacy-trust-hidden');
    }
  }

  /* ---- rating ---- */

  /* Product score from the Okendo widget's server-rendered JSON. Both shapes
     Okendo emits are handled: the reviews widget carries a reviewAggregate,
     the star-rating snippet carries averageRating/reviewCount. */
  function okeData() {
    var tags = document.querySelectorAll('[data-oke-metafield-data]');
    for (var i = 0; i < tags.length; i++) {
      var j;
      try { j = JSON.parse(tags[i].textContent); } catch (e) { continue; }
      if (!j) continue;
      var agg = j.reviewAggregate;
      if (agg && agg.ratingAndReviewCount > 0 && agg.ratingAndReviewValuesTotal > 0) {
        return {
          count: Number(agg.ratingAndReviewCount),
          rating: Number(agg.ratingAndReviewValuesTotal) / Number(agg.ratingAndReviewCount)
        };
      }
      if (j.reviewCount > 0 && j.averageRating) {
        return { count: Number(j.reviewCount), rating: parseFloat(j.averageRating) };
      }
    }
    return null;
  }

  /* Liquid wins when it has a figure; otherwise fill from the widget. */
  function resolve() {
    if (Number(DATA.count) > 0) return true;
    var d = okeData();
    if (!d) return false;
    DATA.rating = d.rating;
    DATA.count = d.count;
    return true;
  }

  /* The rating element. Built here rather than borrowed from a review app, so
     nothing on the page depends on which app happens to be installed. */
  function ratingEl() {
    var el = document.querySelector('.saege-rating');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'saege-rating';
    var a = document.createElement('a');
    a.className = 'saege-rating__link';
    a.href = '#saege-reviews';
    a.setAttribute('aria-label', 'Scroll to reviews');
    a.addEventListener('click', function (e) {
      var w = document.querySelector('.okeReviews.oke-w');
      if (!w) return;
      e.preventDefault();
      w.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    el.appendChild(a);
    return el;
  }

  function label(block, text) {
    if (!text) return false;
    var host = block.querySelector('.saege-rating__link') || block;
    var el = host.querySelector('.saege-rating__label');
    if (!el) {
      el = document.createElement('span');
      el.className = 'saege-rating__label';
      host.appendChild(el);
    }
    if (el.textContent !== text) el.textContent = text;
    return true;
  }

  function productText() {
    return fmt(DATA.rating, DATA.count);
  }

  function doRating() {
    resolve();
    var titleRow = firstVisible('.detail .title-row, .product-detail .title-row');
    if (!titleRow) return false;

    var n = Number(DATA.count);
    var r = Number(DATA.rating);

    if (!(n >= FLOOR) || !(r > 0)) {
      /* Don't conclude "no reviews" until the widget is actually in the
         DOM - it is server-rendered so it normally is, but a re-render
         could have it briefly absent and an early exit would leave the
         rating off a product that has one. */
      if (!document.querySelector('.okeReviews.oke-w')) return false;
      var stale = document.querySelector('.saege-rating');
      if (stale) stale.remove();
      return true;
    }

    /* this product's own score, right of the name */
    var block = ratingEl();
    block.classList.remove('saege-rating-store');
    block.classList.add('saege-rating-product');
    if (block.parentElement !== titleRow) {
      titleRow.appendChild(block);
      titleRow.classList.add('saege-title-row');
    }
    return label(block, productText());
  }

  function start() {
    var a = insertTrust();
    var b = doRating();
    var c = tagOrder();
    hideLegacyTrust();
    if (a && b && c) return;
    var n = 0;
    var iv = setInterval(function () {
      if (!a) a = insertTrust();
      if (!b) b = doRating();
      if (!c) c = tagOrder();
      hideLegacyTrust();
      if ((a && b && c) || ++n > 160) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
